import { render, staticRenderFns } from "./ListResponsavelConfigWhatsappView.vue?vue&type=template&id=50794abe&"
import script from "./ListResponsavelConfigWhatsappView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelConfigWhatsappView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports